<template>
  <div>
    <div class="tutorial-title">{{ $t('tutorial.tutorial_flow-of-use') }}</div>
    <normal-accordion :number-of-panels="4">
      <template #title-1>
        <span class="step">STEP.01</span>
        <span class="title-text">
          {{ $t('tutorial.tutorial_regist-master-information') }}
        </span>
      </template>

      <template #body-1>
        <div class="section">
          <div class="section-no">.01</div>
          <div class="arrow"></div>
          <div class="body-message">
            {{
              $t('tutorial.tutorial_set-company-information-and-add-members')
            }}
          </div>
          <div class="body-image">
            <v-img
              :src="require('@/assets/tutorialImage/tutorial_img_1_1.png')"
              max-height="340"
              max-width="400"
            />
          </div>
          <div class="body-text">
            <div>{{ $t('tutorial.tutorial_reflect-regist-information') }}</div>
            <div>
              {{ $t('tutorial.tutorial_invaite-members-can-check-data') }}
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-no">.02</div>
          <div class="arrow"></div>
          <div class="body-message">
            {{
              $t('tutorial.tutorial_regist-information-from-master-management')
            }}
          </div>
          <div class="body-image">
            <v-img
              :src="require('@/assets/tutorialImage/tutorial_img_1_2.png')"
              max-height="420"
              max-width="350"
            />
          </div>
          <div class="body-text">
            <div>{{ $t('tutorial.tutorial_regist-from-bottom') }}</div>
            <div class="master-management-explanation">
              <div>
                <span class="required">{{ $t('common.input_required') }}</span>
                <span class="required-menu">
                  {{ $t('common.common_product') }}
                </span>
                <span class="master-management-explanation-text">
                  {{ $t('tutorial.tutorial_regist-products') }}
                </span>
              </div>
              <div>
                <span class="required">{{ $t('common.input_required') }}</span>
                <span class="required-menu">
                  {{ $t('common.input_supplier-name') }}
                </span>
                <span class="master-management-explanation-text">
                  {{ $t('tutorial.tutorial_regist-supplier-information') }}
                </span>
              </div>
              <div>
                <span class="required">{{ $t('common.input_required') }}</span>
                <span class="required-menu">
                  {{ $t('common.common_customer-sale') }}
                </span>
                <span class="master-management-explanation-text">
                  {{ $t('tutorial.tutorial_regist-sales-destination') }}
                </span>
              </div>
              <div>
                <span class="required">{{ $t('common.input_required') }}</span>
                <span class="required-menu">
                  {{ $t('common.common_storage') }}
                </span>
                <span class="master-management-explanation-text">
                  {{ $t('tutorial.tutorial_regist--bases-have-inventory') }}
                </span>
              </div>
              <div>
                <span>
                  {{ $t('order.order_desired-warehousing-location') }}
                </span>
                <span class="master-management-explanation-text">
                  {{ $t('tutorial.tutorial_regist-warehousing-distination') }}
                </span>
              </div>
              <div>
                <span>{{ $t('storage.storage_storage-move-reason') }}</span>
                <span class="master-management-explanation-text">
                  {{
                    $t('tutorial.tutorial_regist-reson-move-between-warehouses')
                  }}
                </span>
              </div>
              <div>
                <span>{{ $t('common.common_note-phrase') }}</span>
                <span class="master-management-explanation-text">
                  {{
                    $t(
                      'tutorial.tutorial_can-regist-text-include-purchase-order-or-invoice'
                    )
                  }}
                </span>
              </div>
              <div>
                <span>{{ $t('payment.payment_sale-payment-way') }}</span>
                <span class="master-management-explanation-text">
                  {{
                    $t(
                      'tutorial.tutorial_regist-deposit-and-withdrawal-methods'
                    )
                  }}
                </span>
              </div>
              <div>
                <span>{{ $t('common.common_transfer-account') }}</span>
                <span class="master-management-explanation-text">
                  {{ $t('tutorial.tutorial_regist-transfer-destination') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #title-2>
        <span class="step">STEP.02</span>
        <span class="title-text">
          {{ $t('tutorial.tutorial_regist-stock-quantity') }}
        </span>
      </template>

      <template #body-2>
        <div class="section">
          <div class="section-no">.01</div>
          <div class="arrow"></div>
          <div class="body-message">
            {{ $t('tutorial.tutorial_open-inventory-adjustment') }}
          </div>
          <div class="body-image">
            <v-img
              :src="require('@/assets/tutorialImage/tutorial_img_2_1.png')"
              max-height="320"
              max-width="900"
            />
          </div>
          <div class="body-text">
            <div>
              {{ $t('tutorial.tutorial_input-inventory-adjustment') }}
            </div>
          </div>
        </div>
        <div class="section">
          <div class="section-no">.02</div>
          <div class="arrow"></div>
          <div class="body-message">
            {{ $t('tutorial.tutorial_input-item-stock') }}
          </div>
          <div class="body-image">
            <v-img
              :src="require('@/assets/tutorialImage/tutorial_img_2_2.png')"
              max-height="330"
              max-width="850"
            />
          </div>
        </div>
      </template>

      <template #title-3>
        <span class="step">STEP.03</span>
        <span class="title-text">
          {{ $t('tutorial.tutorial_regist-order-and-orders-received') }}
        </span>
      </template>

      <template #body-3>
        <div class="section">
          <div class="section-no">.01</div>
          <div class="arrow"></div>
          <div class="body-message">
            {{
              $t(
                'tutorial.tutorial_how-to-orders-and-new-sales-and-ec-sales-data-upload'
              )
            }}
          </div>
          <div class="body-image">
            <v-img
              :src="require('@/assets/tutorialImage/tutorial_img_3_1.png')"
              max-height="460"
              max-width="280"
            />
          </div>
          <div class="body-text">
            <div class="body-square">
              <div class="body-square-title">
                {{ $t('common.input_new-order') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_input-manufacturer-and-quantity') }}
              </div>
              <div class="body-square-arrow"></div>
              <div class="body-square-title">
                {{ $t('order.order_order-history') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_after-paying-withdrawal-operation') }}
                <br />
                {{
                  $t('tutorial.tutorial_product-arrives-warehousing-operation')
                }}
                <br />
                {{ $t('tutorial.tutorial_completed-order-operation-complete') }}
              </div>
              <div class="body-square-arrow"></div>
              <div class="body-square-title">
                {{ $t('common.common_others') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_can-output-purchase-orders-etc') }}
              </div>
            </div>
            <div class="body-square">
              <div class="body-square-title">
                {{ $t('sale.sale_new-sale') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_receive-order-regist-sale-amount') }}
              </div>
              <div class="body-square-arrow"></div>
              <div class="body-square-title">
                {{ $t('order.order_order-history') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_after-depositing-deposit-operation') }}
                <br />
                {{ $t('tutorial.tutorial_after-shipping-delivery-operation') }}
                <br />
                {{ $t('tutorial.tutorial_completed-order-operation-complete') }}
              </div>
              <div class="body-square-arrow"></div>
              <div class="body-square-title">
                {{ $t('common.common_others') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_can-output-invoice-etc') }}
              </div>
            </div>
            <div class="body-square">
              <div class="body-square-title">
                {{ $t('jd.jd_jdcom-store-register') }}
              </div>
              <div>{{ $t('tutorial.tutorial_regist-ec-store') }}</div>
              <div class="body-square-arrow"></div>
              <div class="body-square-title">
                {{ $t('jd.jd_jdcom-product-registration') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_link-product-number-and-spes-data') }}
              </div>
              <div class="body-square-arrow"></div>
              <div class="body-square-title">
                {{ $t('common.common_csv-upload') }}
              </div>
              <div>
                {{ $t('tutorial.tutorial_can-regist-all-sales-history') }}
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #title-4>
        <span class="step">STEP.04</span>
        <span class="title-text">
          {{ $t('tutorial.tutorial_output-form-and-accounting') }}
        </span>
      </template>

      <template #body-4>
        <div class="section">
          <div class="section-no">.01</div>
          <div class="arrow"></div>
          <div class="body-message">
            {{ $t('tutorial.tutorial_can-download-pdf-or-csv') }}
          </div>
          <div class="body-image">
            <v-img
              :src="require('@/assets/tutorialImage/tutorial_img_4_1.png')"
              max-height="330"
              max-width="950"
            />
          </div>
          <div class="body-text">
            <div>
              {{ $t('tutorial.tutorial_can-link-accounting-software-etc') }}
            </div>
          </div>
        </div>
      </template>
    </normal-accordion>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { NormalAccordion } from '@/components/items'
import { TO_STATUS } from '@/config/master/tutorial'

export default {
  components: {
    NormalAccordion
  },
  mounted() {
    this.setTutorialStatus({
      status: TO_STATUS.OPENED
    })
  },
  methods: {
    ...mapActions('User', ['setTutorialStatus'])
  }
}
</script>
<style lang="scss" scoped>
$theme-color: #004e88;
$required-color: #be0a0a;
.step {
  font-size: 20px;
  font-weight: 600;
  flex: none;
  padding-left: 30px;
}
.title-text {
  padding-left: 20px;
  font-size: 15px;
  font-weight: 550;
}
.tutorial-title {
  padding-top: 30px;
  padding-left: 35px;
  font-size: 25px;
  font-weight: 600;
  color: $theme-color;
}
.section {
  position: relative;
  padding-top: 20px;
  font-weight: 550;
  .arrow {
    position: absolute;
    top: 65px;
    width: 10px;
    height: calc(100% - 110px);
    background: $theme-color;
    &:after {
      position: absolute;
      content: '';
      top: 100%;
      right: -5px;
      border: 10px solid;
      border-color: transparent;
      border-top: 15px solid $theme-color;
    }
  }
  .section-no {
    font-size: 20px;
    font-weight: 600;
    color: $theme-color;
    position: relative;
    left: -10px;
  }
  /* インデントを揃える */
  .body-message {
    position: relative;
    top: -25px;
    left: 40px;
  }
  .body-text {
    @extend .body-message;
    .master-management-explanation {
      padding-top: 20px;
      position: relative;
      .required {
        margin-right: 10px;
        color: #fff;
        background-color: $required-color;
        font-size: 10px;
        display: inline-block;
        width: 40px;
        text-align: center;
      }
      .required-menu {
        color: $required-color;
      }
      .master-management-explanation-text {
        position: absolute;
        left: 190px;
      }
    }
    .body-square {
      border: 3px solid $theme-color;
      background-color: #fff;
      border-radius: 15px;
      padding: 15px;
      margin: 10px 0px;
      width: 700px;
      .body-square-title {
        padding: 10px;
        font-size: 16px;
        position: relative;
        &:before {
          background-color: $theme-color;
          content: '';
          height: 30px;
          width: 4px;
          position: absolute;
          left: 0px;
          top: 5px;
        }
      }
      .body-square-arrow {
        border-top: 20px solid $theme-color;
        border-right: 40px solid transparent;
        border-bottom: 0px solid transparent;
        border-left: 40px solid transparent;
        width: 50px;
        margin: 10px;
      }
    }
  }
  .body-image {
    @extend .body-message;
    /* TODO 後でpaddingに変えるか検討  */
    margin: 15px 0px;
  }
}
</style>
